/* The Old Riviera theme: behaviour ported from the Lovable React components. */
(function () {
  "use strict";

  var TOR = window.TOR || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    format = format || TOR.moneyFormat || "€{{amount}}";
    var value = "";
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ",";
      decimal = decimal || ".";
      if (isNaN(number) || number == null) return "0";
      number = (number / 100.0).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : "");
    }
    var m = format.match(placeholder);
    switch (m ? m[1] : "amount") {
      case "amount": value = withDelimiters(cents, 2); break;
      case "amount_no_decimals": value = withDelimiters(cents, 0); break;
      case "amount_with_comma_separator": value = withDelimiters(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = withDelimiters(cents, 0, ".", ","); break;
      case "amount_with_apostrophe_separator": value = withDelimiters(cents, 2, "'", "."); break;
      case "amount_with_space_separator": value = withDelimiters(cents, 2, " ", ","); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  TOR.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $("#tor-toast");
    if (!el) return;
    el.textContent = msg;
    el.style.opacity = "1";
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.style.opacity = "0"; }, 2600);
  }
  TOR.toast = toast;

  /* ---------- Scroll lock ---------- */
  // One lock per owner (menu, cart, sheet, upsell): opening twice or closing an owner that
  // never locked can't leave the page stuck (a counter did: upsell popup closed over the open cart).
  var locks = {};
  function lockScroll(on, who) {
    who = who || "misc";
    if (on) locks[who] = 1; else delete locks[who];
    var v = Object.keys(locks).length ? "hidden" : "";
    document.documentElement.style.overflow = v;
    document.body.style.overflow = v;
  }

  /* ---------- Reveal (useReveal) ---------- */
  function initReveal(root) {
    var targets = $$(".reveal:not(.is-visible)", root);
    if (!targets.length) return;
    var fallback = setTimeout(function () { targets.forEach(function (el) { el.classList.add("is-visible"); }); }, 1200);
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = Math.max(0, targets.indexOf(el) % 6) * 90;
        setTimeout(function () { el.classList.add("is-visible"); }, delay);
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    targets.forEach(function (el) { io.observe(el); });
    void fallback;
  }

  /* ---------- Header: sticky pinning, mega menu, overlay ---------- */
  function initHeader() {
    var root = $("[data-header-root]");
    if (!root) return;
    var header = $("[data-header]", root);
    var sectionEl = root.closest(".section-header") || root.parentElement;
    var overlay = $("[data-menu-overlay]", root);
    var toggles = $$("[data-menu-toggle]", root);
    var spacer = $("[data-header-spacer]", root);
    var open = false;

    function placeOverlay() {
      if (!overlay || !header) return;
      overlay.style.top = Math.max(0, header.getBoundingClientRect().bottom) + "px";
    }
    function setMenu(next) {
      if (open === next || !overlay) return;
      open = next;
      if (open) {
        var pinned = sectionEl.getBoundingClientRect().top <= 0 && window.scrollY > 0;
        if (pinned) {
          spacer.style.height = sectionEl.offsetHeight + "px";
          spacer.hidden = false;
          sectionEl.classList.add("is-pinned");
        }
        placeOverlay();
        overlay.setAttribute("data-open", "");
        overlay.classList.remove("pointer-events-none");
        overlay.setAttribute("aria-hidden", "false");
        closeMega();
      } else {
        overlay.removeAttribute("data-open");
        overlay.classList.add("pointer-events-none");
        overlay.setAttribute("aria-hidden", "true");
        sectionEl.classList.remove("is-pinned");
        spacer.hidden = true;
      }
      toggles.forEach(function (t) {
        t.setAttribute("aria-expanded", String(open));
        t.setAttribute("aria-label", open ? t.dataset.labelClose : t.dataset.labelOpen);
      });
      lockScroll(open, "menu");
    }
    toggles.forEach(function (t) { t.addEventListener("click", function () { setMenu(!open); }); });
    $$("[data-menu-close]", root).forEach(function (el) { el.addEventListener("click", function () { setMenu(false); }); });
    window.addEventListener("resize", function () { if (open) placeOverlay(); });
    window.addEventListener("scroll", function () { if (open) placeOverlay(); }, { passive: true });

    // Expandable groups in the overlay (one open per level)
    $$("[data-expand]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var id = btn.dataset.expand;
        var panels = $$('[data-expand-panel="' + id + '"]', root);
        var willOpen = !panels.length || !panels[0].hasAttribute("data-open");
        var isGroup = id.indexOf("g-") === 0;
        // close siblings at the same level
        $$("[data-expand-panel]", root).forEach(function (p) {
          var pid = p.dataset.expandPanel;
          if (pid !== id && (pid.indexOf("g-") === 0) === isGroup) {
            p.removeAttribute("data-open");
            $$('[data-expand="' + pid + '"]', root).forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
          }
        });
        panels.forEach(function (p) { willOpen ? p.setAttribute("data-open", "") : p.removeAttribute("data-open"); });
        $$('[data-expand="' + id + '"]', root).forEach(function (b) { b.setAttribute("aria-expanded", String(willOpen)); });
      });
    });

    // Mega menu (desktop)
    var current = null;
    function closeMega() {
      current = null;
      $$("[data-mega-panel]", root).forEach(function (p) { p.hidden = true; });
      $$("[data-mega-trigger]", root).forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    }
    function openMega(id) {
      if (current === id) return;
      closeMega();
      current = id;
      var panel = $('[data-mega-panel="' + id + '"]', root);
      if (panel) panel.hidden = false;
      $$('[data-mega-trigger="' + id + '"]', root).forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
    }
    $$("[data-mega-trigger]", root).forEach(function (b) {
      b.addEventListener("mouseenter", function () { openMega(b.dataset.megaTrigger); });
      b.addEventListener("click", function () {
        current === b.dataset.megaTrigger ? closeMega() : openMega(b.dataset.megaTrigger);
      });
    });
    $$("[data-mega-close]", root).forEach(function (el) { el.addEventListener("mouseenter", closeMega); });
    if (header) header.addEventListener("mouseleave", closeMega);
    $$("[data-mega-panel] a", root).forEach(function (a) { a.addEventListener("click", closeMega); });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { setMenu(false); closeMega(); }
    });
  }

  /* ---------- Cart ---------- */
  // Watch gift-with-purchase helpers (see Cart.syncDiscount)
  var WATCH_GIFT_NAMES = ["Bracciale", "Collana", "Porta orologi"];
  function isGiftLine(it) {
    var v = (TOR.watchGift || {}).v || [];
    return !!it && !!it.variant_id && v.indexOf(it.variant_id) >= 0;
  }
  // pieces in the cart, free watch gifts excluded (header badge)
  function pieceCount(c) {
    var n = (c && c.item_count) || 0;
    ((c && c.items) || []).forEach(function (it) { if (isGiftLine(it)) n -= it.quantity; });
    return n;
  }
  function isWatchItem(it) { return /-watch(-\d+)?$/.test((it && it.handle) || ""); }
  var Cart = {
    drawer: function () { return $("[data-cart-drawer]"); },
    isOpen: false,
    open: function () {
      var d = this.drawer();
      if (!d) { window.location.href = TOR.routes.cart; return; }
      lockScroll(true, "cart");
      this.isOpen = true;
      d.setAttribute("data-open", "");
      d.classList.remove("pointer-events-none");
      d.setAttribute("aria-hidden", "false");
      startTimer();
    },
    close: function () {
      var d = this.drawer();
      if (!d || !this.isOpen) return;
      this.isOpen = false;
      d.removeAttribute("data-open");
      d.classList.add("pointer-events-none");
      d.setAttribute("aria-hidden", "true");
      lockScroll(false, "cart");
    },
    render: function (sections) {
      var html = sections && sections["cart-drawer"];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fresh = $("[data-cart-drawer]", doc);
      var old = this.drawer();
      if (!fresh || !old) return;
      if (this.isOpen) {
        fresh.setAttribute("data-open", "");
        fresh.classList.remove("pointer-events-none");
        fresh.setAttribute("aria-hidden", "false");
        // keep the panel in place: no slide-in animation on refresh
        var panel = fresh.querySelector('[role="dialog"]');
        if (panel) { panel.style.transition = "none"; requestAnimationFrame(function () { panel.style.transition = ""; }); }
      }
      old.replaceWith(fresh);
      startTimer();
      renderCartUpsell();
    },
    updateCount: function (count) {
      $$("[data-cart-count]").forEach(function (el) {
        el.textContent = count;
        el.hidden = !count;
      });
    },
    request: function (url, body, noSections) {
      if (!noSections) {
        body.sections = "cart-drawer";
        body.sections_url = window.location.pathname;
      }
      return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw new Error(data.description || data.message || "Error");
          return data;
        });
      });
    },
    refreshCount: function () {
      return fetch(TOR.routes.cart + ".js").then(function (r) { return r.json(); }).then(function (c) { Cart.updateCount(pieceCount(c)); return c; });
    },
    // Sconto bundle come su Lovable: codice Duo con 2 pezzi, Trio con 3+, nessuno con 1.
    // Gli altri codici già nel carrello (es. quello del popup) restano.
    // cart: cart JSON already in hand (skips a /cart.js round trip); attrs: attributes to write in the same call.
    // Without sections it always ends with one update that renders the drawer.
    syncDiscount: function (sections, cart, attrs) {
      var self = this, b = TOR.bundle || {};
      var up = TOR.upsell || {};
      // RIVIERA10 = the old Duo code: carts from before the switch to 15% still carry it, so it is always removed
      var bundleCodes = [b.duoCode, b.trioCode, up.code, "RIVIERA10"].filter(Boolean).map(function (c) { return c.toUpperCase(); });
      var finish = function (body) {
        if (!body.discount && !body.attributes && !body.updates && sections) { self.render(sections); return Promise.resolve(); }
        return self.request(TOR.routes.cartUpdate + ".js", body).catch(function (e) {
          // a gift line that cannot be added (sold out, unpublished) must never block the discounts
          if (!body.updates) throw e;
          delete body.updates;
          return self.request(TOR.routes.cartUpdate + ".js", body);
        }).then(function (data) { self.render(data.sections); });
      };
      if (!bundleCodes.length && !(TOR.watchGift || {}).on) return finish(attrs ? { attributes: attrs } : {});
      var get = cart ? Promise.resolve(cart) : fetch(TOR.routes.cart + ".js").then(function (r) { return r.json(); });
      return get.then(function (c) {
        if (attrs) c.attributes = Object.assign({}, c.attributes, attrs);
        self.updateCount(pieceCount(c));
        // pieces added from the upsell popup carry the hidden property _upsell: they get the popup code, not the Duo one
        var isUp = function (it) { return it.properties && it.properties._upsell; };
        var regular = 0, hasUp = false, pieces = 0, watches = 0;
        (c.items || []).forEach(function (it) {
          if (isGiftLine(it)) return; // free watch gifts never count as pieces
          pieces += it.quantity;
          if (isWatchItem(it)) watches += it.quantity;
          if (isUp(it)) hasUp = true; else regular += it.quantity;
        });
        var wantList = [];
        if (offerExpired(c)) regular = 0, hasUp = false;
        if (regular >= 2 && b.duoCode) wantList.push(b.duoCode); // trio code retired: 3+ pieces keep the Duo discount
        if (hasUp && up.code) wantList.push(up.code);
        var have = (c.discount_codes || []).map(function (d) { return d.code; });
        var keep = have.filter(function (code) { return bundleCodes.indexOf(code.toUpperCase()) < 0; });
        var next = keep.concat(wantList);
        var same = next.length === have.length && next.every(function (code) {
          return have.some(function (h) { return h.toUpperCase() === code.toUpperCase(); });
        });
        // The mystery gift from 2 pieces is written on the order (visible attribute) so it gets packed.
        // Not a 0 EUR line: the -40% code discounts the cheapest piece and would land on it.
        // Watch gifts: 1 watch = bracelet, 2 = + necklace, 3+ = + watch holder (chosen by the store).
        // Always written on the order; when the gift products are set in the theme settings they are also 0 EUR lines.
        var wg = TOR.watchGift || {}, tier = wg.on ? Math.min(watches, 3) : 0;
        var noMystery = wg.on && wg.noMystery && watches > 0;
        var GIFT = "Regalo segreto", giftNow = (c.attributes || {})[GIFT] || "";
        var giftWant = TOR.gift && pieces >= 2 && !noMystery ? "Sì, da mettere nel pacco" : "";
        var WGA = "Regali orologi", wgNow = (c.attributes || {})[WGA] || "";
        var wgWant = WATCH_GIFT_NAMES.slice(0, tier).join(" + ");
        var body = {}, setAttr = function (k, v) { body.attributes = body.attributes || {}; body.attributes[k] = v; };
        if (!same) body.discount = next.join(",");
        if (attrs) body.attributes = Object.assign({}, attrs);
        if (giftNow !== giftWant) setAttr(GIFT, giftWant);
        if (wgNow !== wgWant) setAttr(WGA, wgWant);
        (wg.v || []).forEach(function (vid, k) {
          if (!vid) return;
          var want = k < tier ? 1 : 0, have = 0;
          (c.items || []).forEach(function (it) { if (it.variant_id === vid) have += it.quantity; });
          if (have !== want) { body.updates = body.updates || {}; body.updates[vid] = want; }
        });
        return finish(body);
      }).catch(function () { if (sections) self.render(sections); else return self.request(TOR.routes.cartUpdate + ".js", {}).then(function (data) { self.render(data.sections); }); });
    },
    // Fast path: the drawer opens at once with a loading bar, then add.js + cart.js + one update
    // (timer, discount codes, gift) that also renders the drawer.
    add: function (items) {
      var self = this, d = this.drawer();
      var up = items.some(function (it) { return it.properties && it.properties._upsell; });
      if (d && !up) { self.open(); d.setAttribute("aria-busy", "true"); }
      if (!up) document.dispatchEvent(new CustomEvent("tor:adding", { detail: { items: items } }));
      return this.request(TOR.routes.cartAdd + ".js", { items: items }, true).then(function () {
        return fetch(TOR.routes.cart + ".js").then(function (r) { return r.json(); });
      }).then(function (c) {
        // a new piece starts a new reservation: the cart timer (and its discounts) start over
        var attrs = !up && TOR.cartTimerMinutes ? { _reserved_until: String(Date.now() + TOR.cartTimerMinutes * 60000) } : null;
        self.updateCount(pieceCount(c));
        items.forEach(function (it) {
          var line = (c.items || []).filter(function (l) { return l.variant_id === it.id; })[0] || {};
          metaTrack("AddToCart", { content_ids: [String(it.id)], content_name: line.product_title, content_type: "product",
            value: (line.final_price || line.price || 0) * (it.quantity || 1) / 100, currency: metaCurrency(c) });
        });
        // the popup opens at once with this cart, while the drawer finishes its update underneath
        if (!up) document.dispatchEvent(new CustomEvent("tor:added", { detail: { items: items, cart: Object.assign({}, c, { attributes: Object.assign({}, c.attributes, attrs) }) } }));
        return self.syncDiscount(null, c, attrs).then(function () {
          self.open();
          return c;
        });
      }).catch(function (e) { var dd = self.drawer(); if (dd) dd.removeAttribute("aria-busy"); if (!up) document.dispatchEvent(new CustomEvent("tor:addfail")); toast(e.message); throw e; });
    },
    change: function (line, quantity) {
      var self = this;
      return this.request(TOR.routes.cartChange + ".js", { line: line, quantity: quantity }, true).then(function (data) {
        self.updateCount(pieceCount(data));
        return self.syncDiscount(null, data).then(function () { return data; });
      }).catch(function (e) { toast(e.message); });
    }
  };
  TOR.cart = Cart;
  // Checkout: instant feedback (loading bar, dimmed button) while Shopify opens the checkout
  document.addEventListener("submit", function (e) {
    var d = e.target.closest && e.target.closest("[data-cart-drawer]");
    if (!d) return;
    d.setAttribute("aria-busy", "true");
    $$('button[name="checkout"]', d).forEach(function (b) { b.style.opacity = "0.75"; b.style.pointerEvents = "none"; });
  });
  window.addEventListener("pageshow", function () {
    var d = Cart.drawer();
    if (!d) return;
    d.removeAttribute("aria-busy");
    $$('button[name="checkout"]', d).forEach(function (b) { b.style.opacity = ""; b.style.pointerEvents = ""; });
  });

  // Pieces offered at -% (popup and cart carousel): same matching as the Duo 2nd piece:
  // same gender, complementary category, same tone, at most 3 per line (popup: up to 20), a little randomness.
  function upsellMatch(pool, baseHandle, baseTitle, exclude, perLineMax) {
    var cat = function (p) {
      var t = (p.title + " " + p.handle).toLowerCase();
      return /watch|orolog|chrono/.test(t) ? "w" : /bracelet|bracciale/.test(t) ? "b" : /necklace|collana|chain|cross|crucifix/.test(t) ? "n" : /sunglass|occhial/.test(t) ? "s" : "o";
    };
    var tone = function (t) {
      t = t.toLowerCase();
      return /rose ?gold|oro rosa/.test(t) ? "rg" : /silver|argento|steel|acciaio/.test(t) ? "si" : /gold|oro/.test(t) ? "go" : null;
    };
    var women = function (h) {
      h = " " + h.replace(/^the-/, "").replace(/-\d+$/, "").split("-").join(" ") + " ";
      return /^ amalfi (black gold|full gold|full gold black|full gold pearl) watch $/.test(h) ||
        /^ (mirage|riviera|dolcevita|positano) .*watch $/.test(h) || /^ (cannes|fortuna) .*bracelet $/.test(h);
    };
    var baseW = women(baseHandle), baseCat = cat({ title: baseTitle, handle: baseHandle }), baseTone = tone(baseTitle);
    var matchCat = { w: "b", b: "w", n: "s", s: "n", o: "s" }[baseCat] || "b";
    var perLine = {};
    return pool.map(function (p) {
      return { p: p, v: p.variants.filter(function (x) { return x.available; })[0] };
    }).filter(function (x) {
      return x.v && exclude.indexOf(x.p.handle) < 0 && women(x.p.handle) === baseW;
    }).map(function (x) {
      var c2 = cat(x.p);
      x.s = (c2 === matchCat ? 0 : c2 === baseCat ? 3 : 2) + (baseTone && tone(x.p.title) !== baseTone ? 1 : 0) + Math.random() * 0.9;
      return x;
    }).sort(function (a, b) { return a.s - b.s; }).filter(function (x) {
      var line = x.p.handle.split("-").slice(0, 2).join("-");
      perLine[line] = (perLine[line] || 0) + 1;
      return perLine[line] <= (perLineMax || 3);
    });
  }

  // Cart "+1 at -%" carousel: the pool comes from the upsell-pool section (visitor's currency), loaded once per page.
  var cuPool = null, cuPicks = {};
  function loadUpsellPool() {
    if (!cuPool) {
      cuPool = fetch(TOR.routes.root.replace(/\/$/, "") + "/?section_id=upsell-pool").then(function (r) { return r.text(); }).then(function (html) {
        var el = new DOMParser().parseFromString(html, "text/html").querySelector("[data-pool]");
        return el ? JSON.parse(el.textContent) : [];
      }).catch(function () { cuPool = null; return []; });
    }
    return cuPool;
  }
  function renderCartUpsell() {
    var box = $("[data-cart-upsell]"), up = TOR.upsell || {};
    if (!box || !up.pct) return; // the section only prints the box when the offer is on
    var track = $("[data-cu-track]", box), tpl = $("template[data-cu-item]", box), labels = {};
    try { labels = JSON.parse($("[data-cu-labels]", box).textContent); } catch (e) {}
    var base = box.dataset.baseHandle, upHandle = box.dataset.up || "";
    var inCart = (box.dataset.inCart || "").split(",").filter(Boolean);
    var cheapest = parseInt(box.dataset.cheapest || "0", 10) || Infinity;
    loadUpsellPool().then(function (pool) {
      if (!pool.length || !document.body.contains(box)) return;
      // keep the same picks while the base piece does not change (no reshuffle on every cart refresh)
      var key = base + "|" + inCart.join(",");
      if (!cuPicks[key]) cuPicks[key] = upsellMatch(pool, base, box.dataset.baseTitle || "", inCart).slice(0, 12);
      var cands = cuPicks[key].slice();
      if (upHandle) {
        var at = cands.findIndex(function (x) { return x.p.handle === upHandle; });
        var hit = at >= 0 ? cands.splice(at, 1)[0] : pool.filter(function (p) { return p.handle === upHandle; }).map(function (p) { return { p: p, v: p.variants[0] }; })[0];
        if (hit) cands.unshift(hit);
      }
      track.innerHTML = "";
      cands.forEach(function (x) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        $("[data-cu-link]", node).href = x.p.url;
        var img = $("[data-cu-img]", node); img.src = x.p.image; img.alt = x.p.title;
        $("[data-cu-title]", node).textContent = x.p.title;
        var off = Math.round(Math.min(x.v.price, cheapest) * up.pct / 100);
        $("[data-cu-compare]", node).textContent = formatMoney(x.v.price);
        $("[data-cu-price]", node).textContent = formatMoney(x.v.price - off);
        var btn = $("[data-cu-add]", node);
        if (upHandle && x.p.handle === upHandle) {
          btn.textContent = "\u2713 " + (labels.added || "");
          btn.style.cssText = "background: var(--color-green-deep); color: var(--color-cream); opacity: 1";
          btn.disabled = true;
        } else {
          btn.textContent = "+ " + (labels.add || "");
          // the code discounts one piece per order
          if (upHandle) btn.disabled = true;
          btn.addEventListener("click", function () {
            btn.disabled = true;
            Cart.add([{ id: x.v.id, quantity: 1, properties: { _upsell: "1" } }]).catch(function () { btn.disabled = false; });
          });
        }
        track.appendChild(node);
      });
      var step = function (dir) { track.scrollBy({ left: dir * 132 * 2, behavior: "smooth" }); };
      $("[data-cu-prev]", box).onclick = function () { step(-1); };
      $("[data-cu-next]", box).onclick = function () { step(1); };
    });
  }

  // Real reservation timer: the deadline lives on the cart (attribute _reserved_until), so it survives reloads.
  // When it runs out the Duo/popup discounts are dropped (syncDiscount) and the timer does not restart.
  var timerInt = null;
  function offerExpired(c) {
    var until = parseInt((c && c.attributes && c.attributes._reserved_until) || "0", 10);
    return !!(TOR.cartTimerMinutes && until && Date.now() > until);
  }
  function startTimer() {
    clearInterval(timerInt);
    var el = $("[data-cart-timer]");
    if (!el || !TOR.cartTimerMinutes) return;
    if (el.hasAttribute("data-expired")) {
      if (el.hasAttribute("data-resync")) { el.removeAttribute("data-resync"); Cart.syncDiscount(); }
      return;
    }
    var end = parseInt(el.getAttribute("data-until") || "0", 10);
    if (!end) {
      end = Date.now() + TOR.cartTimerMinutes * 60000;
      el.setAttribute("data-until", String(end));
      fetch(TOR.routes.cartUpdate + ".js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ attributes: { _reserved_until: String(end) } })
      }).catch(function () {});
    }
    var tick = function () {
      var t = $("[data-cart-timer]");
      if (!t) return clearInterval(timerInt);
      var left = Math.max(0, end - Date.now());
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      t.textContent = (m < 10 ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s;
      if (!left) {
        clearInterval(timerInt);
        Cart.request(TOR.routes.cartUpdate + ".js", { attributes: { _reserved_until: String(end) } })
          .then(function (data) { return Cart.syncDiscount(data.sections); }).catch(function () {});
      }
    };
    tick();
    timerInt = setInterval(tick, 1000);
  }

  function initCart() {
    document.addEventListener("click", function (e) {
      var t = e.target.closest("[data-cart-open], [data-cart-close], [data-cart-qty], [data-cart-add]");
      if (!t) return;
      if (t.hasAttribute("data-cart-open")) { e.preventDefault(); Cart.open(); return; }
      if (t.hasAttribute("data-cart-close")) { Cart.close(); return; }
      if (t.hasAttribute("data-cart-qty")) {
        t.disabled = true;
        Cart.change(parseInt(t.dataset.line, 10), parseInt(t.dataset.qty, 10));
        return;
      }
      if (t.hasAttribute("data-cart-add")) {
        t.disabled = true;
        Cart.add([{ id: parseInt(t.dataset.cartAdd, 10), quantity: 1 }]).catch(function () {}).then(function () { t.disabled = false; });
      }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") Cart.close(); });
    // Classic product forms (e.g. other templates) open the drawer instead of navigating.
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action$="/cart/add"]')) return;
      e.preventDefault();
      var fd = new FormData(form);
      Cart.add([{ id: parseInt(fd.get("id"), 10), quantity: parseInt(fd.get("quantity") || "1", 10) }]).catch(function () {});
    });
    if (/[?&]cart=open/.test(location.search)) Cart.open();
  }

  /* ---------- Sheets (bottom drawers) ---------- */
  function initSheets() {
    document.addEventListener("click", function (e) {
      var opener = e.target.closest("[data-sheet-open]");
      if (opener) {
        var sheet = $('[data-sheet="' + opener.dataset.sheetOpen + '"]');
        if (sheet) { sheet.hidden = false; lockScroll(true, "sheet"); }
        return;
      }
      var closer = e.target.closest("[data-sheet-close]");
      if (closer) {
        var s = closer.closest("[data-sheet]");
        if (s && !s.hidden) { s.hidden = true; if (!$$("[data-sheet]").some(function (x) { return !x.hidden; })) lockScroll(false, "sheet"); }
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      $$("[data-sheet]").forEach(function (s) { if (!s.hidden) { s.hidden = true; lockScroll(false, "sheet"); } });
    });
  }

  /* ---------- Accordions (FAQ) ---------- */
  function initAccordions() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-accordion-toggle]");
      if (!btn) return;
      var item = btn.closest("[data-accordion]");
      var group = item.closest("[data-accordion-group]");
      var willOpen = !item.hasAttribute("data-open");
      if (group) $$("[data-accordion]", group).forEach(function (it) {
        it.removeAttribute("data-open");
        var b = $("[data-accordion-toggle]", it);
        if (b) b.setAttribute("aria-expanded", "false");
      });
      if (willOpen) item.setAttribute("data-open", "");
      else item.removeAttribute("data-open");
      btn.setAttribute("aria-expanded", String(willOpen));
    });
  }

  /* ---------- Watch Club (area membri): preferiti e caroselli ---------- */
  function initWatchClub() {
    var done = $("[data-club-done]");
    if (done) setTimeout(function () { location.href = done.getAttribute("data-login-url"); }, 3500);
    var sec = $("[data-wc-wardrobe]");
    var list = Wardrobe.items();
    $$("[data-wardrobe-count-text]").forEach(function (el) {
      el.textContent = el.getAttribute("data-wardrobe-count-text").replace("#", list.length);
    });
    if (sec && list.length) {
      var box = $("[data-wc-wardrobe-list]", sec), tpl = $("template[data-wc-wardrobe-item]", sec);
      list.slice(0, 4).forEach(function (it) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        node.href = it.url;
        var img = $("[data-w-image]", node);
        if (it.image) { img.src = it.image; img.alt = it.title; } else img.remove();
        $("[data-w-title]", node).textContent = it.title;
        box.appendChild(node);
      });
      sec.hidden = false;
    }
    $$("[data-wc-rail]").forEach(function (rail) {
      var sc = $("[data-wc-scroller]", rail);
      $$("[data-wc-prev],[data-wc-next]", rail).forEach(function (b) {
        b.addEventListener("click", function () {
          sc.scrollBy({ left: (b.hasAttribute("data-wc-next") ? 1 : -1) * sc.clientWidth * 0.85, behavior: "smooth" });
        });
      });
    });
  }

  /* ---------- Ricerca live (come /cerca su Lovable: risultati mentre scrivi) ---------- */
  function initLiveSearch() {
    var form = $("form[data-live-search]");
    var box = $("[data-search-results]");
    var close = $("[data-search-close]");
    if (close) close.addEventListener("click", function (e) {
      if (window.history.length > 1 && document.referrer && document.referrer.indexOf(location.host) > -1) { e.preventDefault(); history.back(); }
    });
    if (!form || !box) return;
    var input = $('input[name="q"]', form), timer = null, last = input.value.trim(), ctrl = null;
    function run(term) {
      if (term === last) return;
      last = term;
      var url = new URL(form.action, location.origin);
      url.searchParams.set("type", "product");
      if (term) url.searchParams.set("q", term);
      history.replaceState(null, "", url.pathname + url.search);
      url.searchParams.set("section_id", form.getAttribute("data-live-search"));
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      fetch(url.toString(), ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var nb = doc.querySelector("[data-search-results]");
        if (!nb) return;
        box.innerHTML = nb.innerHTML;
        initReveal(box);
      }).catch(function () {});
    }
    input.addEventListener("input", function () {
      clearTimeout(timer);
      timer = setTimeout(function () { run(input.value.trim()); }, 200);
    });
    form.addEventListener("submit", function (e) { e.preventDefault(); clearTimeout(timer); run(input.value.trim()); });
    $$("[data-search-chip]", form.closest("section") || document).forEach(function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        input.value = a.getAttribute("data-search-chip");
        clearTimeout(timer);
        run(input.value.trim());
      });
    });
  }

  /* ---------- Pagine informative: fisarmonica Spedizioni + modulo tracking ---------- */
  function initInfoPages() {
    var OPEN = ["grid-rows-[1fr]", "opacity-100", "mt-4"], CLOSED = ["grid-rows-[0fr]", "opacity-0"];
    function setItem(b, open) {
      var svg = $("svg", b), panel = b.querySelector(":scope > div.grid");
      if (svg) svg.classList.toggle("rotate-180", open);
      if (panel) {
        OPEN.forEach(function (c) { panel.classList.toggle(c, open); });
        CLOSED.forEach(function (c) { panel.classList.toggle(c, !open); });
      }
      b.setAttribute("aria-expanded", String(open));
    }
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-acc-item]");
      if (!b) return;
      var open = b.getAttribute("aria-expanded") !== "true" && !$("svg.rotate-180", b);
      var group = b.closest("[data-acc]");
      if (group) $$("[data-acc-item]", group).forEach(function (x) { setItem(x, false); });
      setItem(b, open);
    });
    $$("[data-track-form]").forEach(function (form) {
      var input = form.querySelector('[name="nums"]'), hidden = form.querySelector('[name="tracking_number"]');
      form.addEventListener("submit", function () { input.value = input.value.trim(); hidden.value = input.value; });
      var n = new URLSearchParams(window.location.search).get("n");
      if (n && n.trim()) { input.value = n.trim(); hidden.value = n.trim(); }
    });
  }

  /* ---------- Meta pixel: ViewContent, AddToCart, InitiateCheckout, Search ---------- */
  // WeTracked loads fbq (only after marketing consent) but sends just PageView from the browser and Purchase
  // from its server: the other funnel events were sent by the Lovable code and stopped with the theme.
  // Events wait up to 15 s for fbq; without consent fbq never appears and nothing is sent.
  var metaQueue = [], metaTimer = null, metaSentUd = "";
  // Advanced matching raises the event match quality: logged-in customer, email/name left in the site forms
  // (popup, newsletter, club), shop country and a stable visitor id (Shopify's _shopify_y cookie).
  function metaUserData() {
    var m = window.torMeta || {}, c = m.customer || {}, saved = {};
    try { saved = JSON.parse(localStorage.getItem("tor_um") || "{}") || {}; } catch (e) {}
    var clean = function (v) { return v ? String(v).trim().toLowerCase() : ""; };
    var ck = (document.cookie.match(/(?:^|; )_shopify_y=([^;]+)/) || [])[1];
    if (!ck) try { ck = localStorage.getItem("tor_eid") || ("v" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10)); localStorage.setItem("tor_eid", ck); } catch (e) {}
    var ud = {
      em: clean(c.em || saved.em), fn: clean(c.fn || saved.fn), ln: clean(c.ln || saved.ln),
      ph: String(c.ph || "").replace(/[^0-9]/g, ""), ct: clean(c.ct).replace(/\s+/g, ""), zp: clean(c.zp).replace(/\s+/g, ""),
      country: clean(c.country || m.country), external_id: c.id ? "c" + c.id : ck ? decodeURIComponent(ck) : ""
    };
    Object.keys(ud).forEach(function (k) { if (!ud[k]) delete ud[k]; });
    return ud;
  }
  function metaIdentify() {
    var ud = metaUserData(), key = JSON.stringify(ud);
    if (key === metaSentUd || key === "{}") return;
    var ids = [];
    try { ids = (window.fbq.getState().pixels || []).map(function (p) { return p.id; }); } catch (e) {}
    if (!ids.length) ids = ["1912397056081012"];
    ids.forEach(function (id) { window.fbq("init", id, ud); });
    metaSentUd = key;
  }
  TOR.metaRemember = function (data) {
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem("tor_um") || "{}") || {}; } catch (e) {}
    Object.keys(data || {}).forEach(function (k) { if (data[k]) saved[k] = String(data[k]).trim().toLowerCase(); });
    try { localStorage.setItem("tor_um", JSON.stringify(saved)); } catch (e) {}
    if (window.fbq) try { metaIdentify(); } catch (e) {}
  };
  function metaFlush() {
    if (!window.fbq) return false;
    try { metaIdentify(); } catch (e) {}
    while (metaQueue.length) { var e = metaQueue.shift(); try { window.fbq("track", e[0], e[1], { eventID: e[2] }); } catch (x) {} }
    return true;
  }
  function metaTrack(name, params) {
    metaQueue.push([name, params || {}, name + "-" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8)]);
    if (metaFlush() || metaTimer) return;
    var tries = 0;
    metaTimer = setInterval(function () { if (metaFlush() || ++tries > 30) { clearInterval(metaTimer); metaTimer = null; } }, 500);
  }
  function metaCurrency(c) { return (c && c.currency) || (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR"; }
  TOR.metaTrack = metaTrack;
  function initMetaEvents() {
    metaFlush() || (function () { var n = 0, t = setInterval(function () { if (metaFlush() || ++n > 30) clearInterval(t); }, 500); })();
    // Search results page (the live search box opens it on Enter)
    var q = /\/search/.test(location.pathname) && new URLSearchParams(location.search).get("q");
    if (q && q.trim()) metaTrack("Search", { search_string: q.trim() });
    // InitiateCheckout from the drawer or the cart page: the event leaves before Shopify opens the checkout
    document.addEventListener("submit", function (e) {
      var form = e.target, btn = e.submitter;
      if (!form.querySelector || !form.querySelector('button[name="checkout"]') || (btn && btn.name !== "checkout")) return;
      if (form.dataset.metaSent) return;
      fetch(TOR.routes.cart + ".js").then(function (r) { return r.json(); }).then(function (c) {
        metaTrack("InitiateCheckout", {
          content_ids: (c.items || []).map(function (i) { return String(i.variant_id); }), content_type: "product",
          value: c.total_price / 100, currency: metaCurrency(c), num_items: c.item_count
        });
      }).catch(function () {});
      if (!window.fbq) return;
      e.preventDefault();
      form.dataset.metaSent = "1";
      if (!form.querySelector('input[name="checkout"]')) { var h = document.createElement("input"); h.type = "hidden"; h.name = "checkout"; h.value = "1"; form.appendChild(h); }
      setTimeout(function () { form.submit(); }, 450);
    }, true);
    window.addEventListener("pageshow", function () { $$("form[data-meta-sent]").forEach(function (f) { delete f.dataset.metaSent; }); });
  }

  /* ---------- Klaviyo onsite (as on Lovable): klaviyo.js + identify + Viewed Product + Added to Cart ---------- */
  // Feeds the browse/cart abandonment flows. Klaviyo only records events for identified visitors
  // (email left on the site, logged-in customer, or arriving from a Klaviyo email). Nothing runs if cookies were rejected.
  function klvRejected() { try { return localStorage.getItem("tor-cookie-consent-v1") === "rejected"; } catch (e) { return false; } }
  function klv() {
    var k = window.torKlaviyo || {};
    if (!k.key || klvRejected()) return null;
    if (!window.klaviyo) {
      window._klOnsite = window._klOnsite || [];
      window.klaviyo = { push: function (c) { window._klOnsite.push(c); } };
    }
    // the Klaviyo app embed (Incorporamenti app) already loads klaviyo.js: loaded here only when it is off
    if (!klv.loaded && !document.querySelector('script[src*="static.klaviyo.com/onsite/js"]')) {
      klv.loaded = true;
      var s = document.createElement("script");
      s.async = true;
      s.src = "https://static.klaviyo.com/onsite/js/" + encodeURIComponent(k.key) + "/klaviyo.js";
      document.head.appendChild(s);
    }
    return window.klaviyo;
  }
  function initKlaviyoOnsite() {
    var k = klv(), d = window.torKlaviyo || {};
    if (!k) return;
    if (d.customer) k.push(["identify", { email: d.customer }]);
    if (d.product && !document.getElementById("viewed_product")) { // the app embed tracks Viewed Product itself
      var p = d.product;
      k.push(["track", "Viewed Product", { ProductName: p.name, ProductID: p.id, Handle: p.handle, Categories: p.cats, ImageURL: p.image, URL: p.url, Brand: "The Old Riviera", Price: p.price, CompareAtPrice: p.compare }]);
      k.push(["trackViewedItem", { Title: p.name, ItemId: p.id, Categories: p.cats, ImageUrl: p.image, Url: p.url, Metadata: { Brand: "The Old Riviera", Price: p.price, CompareAtPrice: p.compare } }]);
    }
    // The Klaviyo web pixel already sends Added to Cart for every add (config {"enableAddedToCartEvents": true}):
    // a second push here doubled the event and could double the abandoned-cart flow.
    var pixelAtc = [].some.call(document.scripts, function (s) { return !s.src && s.text.indexOf("eyJlbmFibGVBZGRlZFRvQ2FydEV2ZW50cyI6IHRydWV9") >= 0; });
    if (!pixelAtc) document.addEventListener("tor:added", function () {
      fetch(TOR.routes.cart + ".js").then(function (r) { return r.json(); }).then(function (c) {
        var last = (c.items || [])[0] || {};
        k.push(["track", "Added to Cart", {
          $value: c.total_price / 100,
          AddedItemProductName: last.product_title, AddedItemProductID: String(last.product_id || ""), AddedItemSKU: last.sku,
          AddedItemImageURL: last.image, AddedItemURL: location.origin + (last.url || ""), AddedItemPrice: (last.final_price || 0) / 100, AddedItemQuantity: last.quantity,
          ItemNames: (c.items || []).map(function (i) { return i.product_title; }),
          CheckoutURL: location.origin + "/checkout",
          Items: (c.items || []).map(function (i) { return { ProductID: String(i.product_id), SKU: i.sku, ProductName: i.product_title, Quantity: i.quantity, ItemPrice: i.final_price / 100, RowTotal: i.final_line_price / 100, ProductURL: location.origin + i.url, ImageURL: i.image }; })
        }]);
      }).catch(function () {});
    });
  }

  /* ---------- Klaviyo: iscrizione diretta alla lista (API pubblica, nessun segreto) ---------- */
  window.torKlaviyoSubscribe = function (email, source, names) {
    var k = window.torKlaviyo || {}, list = k.lists && k.lists[source];
    var kl = email && /^\S+@\S+\.\S+$/.test(email.trim()) ? klv() : null;
    if (kl) kl.push(["identify", { email: email.trim().toLowerCase() }]);
    if (kl && TOR.metaRemember) TOR.metaRemember({ em: email, fn: names && names.first_name, ln: names && names.last_name });
    if (!k.key || !list || !email) return Promise.resolve(false);
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(k.key), {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/vnd.api+json", revision: "2024-10-15" },
      body: JSON.stringify({ data: { type: "subscription", attributes: {
        custom_source: source,
        profile: { data: { type: "profile", attributes: Object.assign({ email: email.trim().toLowerCase(), properties: { source: source, site: location.hostname } }, names || {}) } }
      }, relationships: { list: { data: { type: "list", id: list } } } } })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  };
  function initKlaviyoForms() {
    $$("form[data-klaviyo-source]").forEach(function (form) {
      form.addEventListener("submit", function () {
        var input = form.querySelector('input[type="email"]');
        var fn = form.querySelector('[name="contact[first_name]"]'), ln = form.querySelector('[name="contact[last_name]"]');
        var names = {};
        if (fn && fn.value.trim()) names.first_name = fn.value.trim();
        if (ln && ln.value.trim()) names.last_name = ln.value.trim();
        if (input) window.torKlaviyoSubscribe(input.value, form.dataset.klaviyoSource, names);
      });
    });
  }

  /* ---------- Provenienza della visita nel carrello (per il centro di controllo) ---------- */
  // Come sul sito Lovable: UTM, ad_id e fbclid dell'ultima visita arrivata da un link (inserzione, email)
  // finiscono negli attributi nascosti del carrello (_tor_utm_source, _tor_ad_id, ...), quindi sull'ordine.
  // Il centro di controllo li legge per collegare ogni ordine all'inserzione che l'ha portato.
  var ATTR_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "ad_id", "fbclid"];
  function initAttribution() {
    var p = new URLSearchParams(location.search), got = {}, any = false, saved = null;
    ATTR_KEYS.forEach(function (k) { var v = p.get(k); if (v) { got[k] = v.slice(0, 200); any = true; } });
    try { saved = JSON.parse(localStorage.getItem("tor_attr") || "null"); } catch (e) {}
    if (any) saved = { v: got, at: Date.now(), sent: "" };
    if (!saved || !saved.v || Date.now() - saved.at > 30 * 864e5) return;
    var keep = function () { try { localStorage.setItem("tor_attr", JSON.stringify(saved)); } catch (e) {} };
    keep();
    fetch(TOR.routes.cart + ".js", { credentials: "same-origin" }).then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.token && saved.sent === c.token + "|" + saved.at) return;
      var attrs = {};
      ATTR_KEYS.forEach(function (k) { attrs["_tor_" + k] = saved.v[k] || ""; });
      return fetch(TOR.routes.cartUpdate + ".js", { method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: attrs }) })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart && cart.token) { saved.sent = cart.token + "|" + saved.at; keep(); } });
    }).catch(function () {});
  }

  /* ---------- Tabs (home) ---------- */
  function initTabs() {
    $$("[data-tabs]").forEach(function (root) {
      var tabs = $$("[data-tab]", root);
      // hidden tabs: their lazy photos would only start loading on click (blank cards for a moment),
      // so they are fetched as soon as the finger/mouse gets to the tab, and anyway shortly after the page loads
      var warm = function (panel) {
        $$("[data-product-card] img:first-of-type", panel).forEach(function (img) { img.loading = "eager"; });
      };
      var panelOf = function (tab) { return $('[data-tab-panel="' + tab.dataset.tab + '"]', root); };
      tabs.forEach(function (tab) {
        ["pointerenter", "touchstart", "focus"].forEach(function (ev) {
          tab.addEventListener(ev, function () { var pn = panelOf(tab); if (pn) warm(pn); }, { passive: true, once: true });
        });
      });
      window.addEventListener("load", function () {
        setTimeout(function () { $$("[data-tab-panel]", root).forEach(warm); }, 1500);
      });
      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          tabs.forEach(function (t) { t.setAttribute("aria-selected", String(t === tab)); });
          $$("[data-tab-panel]", root).forEach(function (p) { p.hidden = p.dataset.tabPanel !== tab.dataset.tab; });
          initReveal(root);
        });
      });
      // Scheda Bestseller: i più venduti veri, presi da Shopify dopo il caricamento
      $$("[data-bestsellers]", root).forEach(function (panel) {
        fetch(panel.dataset.bestsellers).then(function (r) { return r.ok ? r.text() : ""; }).then(function (html) {
          if (!html) return;
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var cards = tmp.querySelectorAll("[data-product-card]");
          var grid = panel.querySelector("[data-tab-grid]");
          if (cards.length && grid) {
            grid.innerHTML = "";
            cards.forEach(function (c) { grid.appendChild(c); });
            initReveal(root);
          }
        }).catch(function () {});
      });
    });
  }

  /* ---------- Videos ---------- */
  function initHeroVideo() {
    $$("[data-hero] video").forEach(function (el) {
      el.muted = true; el.defaultMuted = true; el.loop = true; el.playsInline = true;
      var tryPlay = function () { var p = el.play(); if (p && p.catch) p.catch(function () {}); };
      tryPlay();
      el.addEventListener("canplay", tryPlay);
      el.addEventListener("ended", function () { el.currentTime = 0; tryPlay(); });
      document.addEventListener("visibilitychange", function () { if (document.visibilityState === "visible") tryPlay(); });
      window.addEventListener("touchstart", tryPlay, { once: true, passive: true });
    });
  }

  function sectionProgress(el) {
    var r = el.getBoundingClientRect();
    var total = r.height - window.innerHeight;
    return clamp(-r.top / Math.max(1, total), 0, 1);
  }

  // <video data-lazy-src>: gets its src and plays only once it is actually visible
  // (the product video exists twice, mobile and desktop gallery: only the shown one downloads)
  function initLazyVideos(root) {
    if (!("IntersectionObserver" in window)) {
      $$("video[data-lazy-src]", root).forEach(function (v) { v.src = v.getAttribute("data-lazy-src"); v.removeAttribute("data-lazy-src"); v.autoplay = true; });
      return;
    }
    // The src is set a little before the video comes into view (also sideways, in the gallery), with the autoplay
    // attribute: iOS Safari pauses muted videos that leave the screen and resumes only those with autoplay.
    // If the browser refuses autoplay (e.g. iPhone low-power mode) the controls appear, so a tap starts it.
    var play = function (v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.controls = true; });
    };
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = en.target;
        if (v.hasAttribute("data-lazy-src")) {
          if (!en.isIntersecting) return;
          v.muted = true; v.defaultMuted = true;
          v.setAttribute("muted", ""); v.setAttribute("playsinline", ""); v.setAttribute("autoplay", "");
          v.preload = "auto";
          v.src = v.getAttribute("data-lazy-src");
          v.removeAttribute("data-lazy-src");
        }
        if (en.isIntersecting) play(v); else if (!v.paused) v.pause();
      });
    }, { rootMargin: "300px 100% 300px 100%" });
    $$("video[data-lazy-src]", root).forEach(function (v) { io.observe(v); });
  }

  function initScrollVideo() {
    $$("[data-scroll-video]").forEach(function (wrap) {
      var v = $("video", wrap);
      if (!v) return;
      var target = 0, current = 0, running = false;
      var unlock = function () { var p = v.play(); if (p && p.then) p.then(function () { v.pause(); }).catch(function () {}); };
      // the video (several MB) only starts downloading when the section is about a screen away
      var near = new IntersectionObserver(function (es) {
        if (!es.some(function (en) { return en.isIntersecting; })) return;
        near.disconnect();
        v.preload = "auto";
        v.load();
        unlock();
        window.addEventListener("touchstart", unlock, { once: true, passive: true });
      }, { rootMargin: "100% 0px" });
      near.observe(wrap);
      var onScroll = function () { target = sectionProgress(wrap) * (v.duration || 0); };
      var tick = function () {
        current += (target - current) * 0.15;
        if (v.duration && Math.abs(v.currentTime - current) > 0.02) v.currentTime = current;
        if (running) requestAnimationFrame(tick);
      };
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting && !running) { running = true; requestAnimationFrame(tick); }
          else if (!en.isIntersecting) running = false;
        });
      }).observe(wrap);
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      v.addEventListener("loadedmetadata", onScroll);
    });
  }

  /* ---------- Jewel carousel (3D) ---------- */
  function initJewel() {
    $$("[data-jewel]").forEach(function (wrap) {
      var ring = $("[data-jewel-ring]", wrap);
      if (!ring) return;
      var cards = Array.prototype.slice.call(ring.children);
      var infos = $$("[data-jewel-info]", wrap);
      var dots = $$("[data-jewel-dot]", wrap);
      var indexEl = $("[data-jewel-index]", wrap);
      var n = cards.length, cur = 0, active = -1, running = false;
      if (!n) return;
      var setActive = function (a) {
        if (a === active) return;
        active = a;
        cards.forEach(function (c, i) { i === a ? c.setAttribute("data-active", "") : c.removeAttribute("data-active"); });
        infos.forEach(function (el, i) { el.hidden = i !== a; });
        dots.forEach(function (d, i) { i <= a ? d.setAttribute("data-on", "") : d.removeAttribute("data-on"); });
        if (indexEl) {
          indexEl.textContent = (a + 1 < 10 ? "0" : "") + (a + 1);
          indexEl.style.animation = "none"; void indexEl.offsetWidth; indexEl.style.animation = "";
        }
      };
      var loop = function () {
        var target = sectionProgress(wrap) * (n - 1);
        cur += (target - cur) * 0.1;
        for (var i = 0; i < n; i++) {
          var d = i - cur, ad = Math.abs(d), el = cards[i];
          el.style.transform = "translate(-50%,-50%) translateX(" + d * 62 + "%) translateZ(" + -ad * 180 + "px) rotateY(" + -d * 28 + "deg) scale(" + (1 - Math.min(ad, 3) * 0.06) + ")";
          el.style.opacity = String(Math.max(0, 1 - ad * 0.28));
          el.style.zIndex = String(100 - Math.round(ad * 10));
          el.style.filter = "blur(" + Math.min(ad, 3) * 1.2 + "px)";
        }
        setActive(clamp(Math.round(cur), 0, n - 1));
        if (running) requestAnimationFrame(loop);
      };
      loop();
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting && !running) { running = true; requestAnimationFrame(loop); }
          else if (!en.isIntersecting) running = false;
        });
      }).observe(wrap);
    });
  }

  /* ---------- Manifesto (horizontal scroll) ---------- */
  function initManifesto() {
    $$("[data-manifesto]").forEach(function (wrap) {
      var track = $("[data-manifesto-track]", wrap);
      var bar = $("[data-manifesto-bar]", wrap);
      var pars = $$("[data-par]", wrap);
      var panels = pars.length;
      var raf = 0;
      var update = function () {
        raf = 0;
        var p = sectionProgress(wrap);
        var max = track.scrollWidth - window.innerWidth;
        track.style.transform = "translate3d(" + -p * max + "px,0,0)";
        if (bar) bar.style.transform = "scaleX(" + p + ")";
        pars.forEach(function (el, i) {
          var local = p * (panels - 1) - i;
          el.style.transform = "translate3d(" + local * -120 + "px,0,0)";
          el.style.opacity = String(Math.max(0.15, 1 - Math.abs(local) * 0.8));
        });
      };
      var onScroll = function () { if (!raf) raf = requestAnimationFrame(update); };
      update();
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
    });
  }

  /* ---------- Reviews (featured rotation + velocity rows) ---------- */
  function initReviews() {
    $$("[data-reviews]").forEach(function (sec) {
      var slides = $$("[data-review-slide]", sec);
      var dots = $$("[data-review-dot]", sec);
      var DURATION = 6000, idx = 0, timer;
      var show = function (i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.hidden = k !== idx; });
        dots.forEach(function (d, k) {
          var bar = d.firstElementChild;
          bar.style.animation = "none";
          void bar.offsetWidth;
          if (k < idx) { bar.style.transform = "scaleX(1)"; }
          else if (k === idx) { bar.style.transform = ""; bar.style.animation = "recBar " + DURATION + "ms linear both"; }
          else { bar.style.transform = "scaleX(0)"; }
        });
        clearTimeout(timer);
        timer = setTimeout(function () { show(idx + 1); }, DURATION);
      };
      if (slides.length) show(0);
      var prev = $("[data-review-prev]", sec), next = $("[data-review-next]", sec);
      if (prev) prev.addEventListener("click", function () { show(idx - 1); });
      if (next) next.addEventListener("click", function () { show(idx + 1); });
      dots.forEach(function (d, k) { d.addEventListener("click", function () { show(k); }); });

      var a = $('[data-review-row="a"]', sec), b = $('[data-review-row="b"]', sec);
      if (!a || !b || reduceMotion) return;
      var drift = 0, lastY = window.scrollY, vel = 0, running = false;
      var loop = function () {
        var y = window.scrollY;
        vel += (y - lastY - vel) * 0.1;
        lastY = y;
        drift += 0.4 + Math.abs(vel) * 0.6;
        var skew = clamp(vel * 0.25, -8, 8);
        var wA = a.scrollWidth / 2, wB = b.scrollWidth / 2;
        a.style.transform = "translate3d(" + -(drift % wA) + "px,0,0) skewX(" + -skew + "deg)";
        b.style.transform = "translate3d(" + (-wB + (drift % wB)) + "px,0,0) skewX(" + skew + "deg)";
        if (running) requestAnimationFrame(loop);
      };
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting && !running) { running = true; requestAnimationFrame(loop); }
          else if (!en.isIntersecting) running = false;
        });
      }).observe(sec);
    });
  }

  /* ---------- Product page ---------- */
  /* ---------- Abbinalo con (PairWith su Lovable): stesso metallo/colore, due tipi diversi ---------- */
  function catOf(t) {
    return /watch|orologio/i.test(t) ? "watch" : /bracelet|bracciale/i.test(t) ? "bracelet" : /necklace|chain|collana/i.test(t) ? "necklace" : /sunglass|occhiali/i.test(t) ? "sunglasses" : /pochette/i.test(t) ? "pochette" : "other";
  }
  function toneOf(t) {
    var s = t.toLowerCase();
    if (/rose ?gold|oro rosa/.test(s)) return "rosegold";
    if (/silver|argento|steel|acciaio/.test(s)) return "silver";
    if (/gold|oro/.test(s)) return "gold";
    if (/black|nero/.test(s)) return "black";
    return null;
  }
  var ACCENTS = [["black", /black|nero/], ["brown", /brown|marrone|tan|cognac/], ["blue", /blue|navy|blu/], ["green", /green|verde/], ["white", /white|ice|bianco|cream/], ["red", /red|rosso|burgundy/], ["grey", /grey|gray|grigio/]];
  function accentsOf(t) {
    var s = t.toLowerCase().replace(/rose ?gold|oro rosa/g, "");
    return ACCENTS.filter(function (a) { return a[1].test(s); }).map(function (a) { return a[0]; });
  }
  function isWomens(title, handle) {
    var t = title.trim();
    var amalfiW = /^the amalfi (black\s*\/\s*gold|full gold(\s*\/\s*(black|pearl))?) watch$/i.test(t);
    if (/^the amalfi\b/i.test(t) && /watch|orolog/i.test(t) && !amalfiW) return false;
    if (amalfiW) return true;
    var id = t + " " + (handle || "").replace(/-/g, " ");
    if (/\bthe (mirage|riviera|dolcevita|positano)\b/i.test(id) && /watch|orologio/i.test(id)) return true;
    if (/\bthe (cannes|fortuna)\b/i.test(id) && /bracelet|bracciale/i.test(id)) return true;
    return /\b(women|women's|womens|donna|lady|ladies|per lei|for her|femme|mujer)\b/i.test(id);
  }
  function initPairWith(root, product, pool) {
    var sec = $("[data-pair-with]", root);
    if (!sec || !pool.length) return;
    // same matching as the Duo 2nd piece: same gender, complementary category, same tone
    var cat = function (p) {
      var t = (p.title + " " + p.handle).toLowerCase();
      return /watch|orolog|chrono/.test(t) ? "w" : /bracelet|bracciale/.test(t) ? "b" : /necklace|collana|chain|cross|crucifix/.test(t) ? "n" : /sunglass|occhial/.test(t) ? "s" : "o";
    };
    var tone = function (t) {
      var s = t.toLowerCase();
      return /rose ?gold|oro rosa/.test(s) ? "rg" : /silver|argento|steel|acciaio/.test(s) ? "si" : /gold|oro/.test(s) ? "go" : null;
    };
    var women = function (h) {
      h = " " + h.replace(/^the-/, "").replace(/-\d+$/, "").split("-").join(" ") + " ";
      return /^ amalfi (black gold|full gold|full gold black|full gold pearl) watch $/.test(h) ||
        /^ (mirage|riviera|dolcevita|positano) .*watch $/.test(h) || /^ (cannes|fortuna) .*bracelet $/.test(h);
    };
    var baseCat = cat(product), baseTone = tone(product.title), baseWomen = women(product.handle);
    // two complementary categories: watch -> bracelet + necklace, necklace -> sunglasses + bracelet, ...
    var wanted = { w: ["b", "n"], b: ["w", "n"], n: ["s", "b"], s: ["n", "b"], o: ["s", "b"] }[baseCat] || ["b", "n"];
    var line = product.handle.split("-").slice(0, 2).join("-");
    var cands = pool.filter(function (p) {
      return p.handle !== product.handle && p.handle.indexOf(line + "-") !== 0 && p.variants.some(function (v) { return v.available; });
    });
    var score = function (p, want) {
      var sc = 0, c = cat(p);
      if (women(p.handle) !== baseWomen) sc += 10;
      if (c !== want) sc += c === baseCat ? 8 : 2;
      if (baseTone && tone(p.title) !== baseTone) sc += 1;
      return sc + Math.random() * 0.5;
    };
    var out = [];
    wanted.forEach(function (want) {
      var best = cands.filter(function (p) { return out.indexOf(p) < 0; })
        .map(function (p) { return { p: p, s: score(p, want) + (out.some(function (o) { return cat(o) === cat(p); }) ? 5 : 0) }; })
        .sort(function (x, y) { return x.s - y.s; })[0];
      if (best) out.push(best.p);
    });
    if (!out.length) return;
    var list = $("[data-pair-list]", sec), tpl = $("template[data-pair-item]", sec);
    out.forEach(function (p) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      var a = $("[data-p-link]", node); a.href = p.url || ("/products/" + p.handle);
      var img = $("[data-p-img]", node); img.src = p.image_l || p.image; img.alt = p.alt || p.title;
      $("[data-p-title]", node).textContent = p.title;
      var cheap = p.variants.slice().sort(function (x, y) { return x.price - y.price; })[0];
      var min = cheap.price;
      $("[data-p-price]", node).textContent = formatMoney(min);
      // discounted price: the compare-at struck through and the % off, like the main price
      if (cheap.compare_at_price > min) {
        var cmp = $("[data-p-compare]", node), off = $("[data-p-off]", node);
        if (cmp) { cmp.textContent = formatMoney(cheap.compare_at_price); cmp.hidden = false; }
        if (off) { off.textContent = "−" + Math.round((cheap.compare_at_price - min) * 100 / cheap.compare_at_price) + "%"; off.hidden = false; }
        $("[data-p-price]", node).style.color = "var(--color-terracotta)";
      }
      var btn = $("[data-p-add]", node), label = $("[data-p-label]", node);
      label.textContent = sec.dataset.labelAdd;
      btn.addEventListener("click", function () {
        btn.disabled = true;
        Cart.add([{ id: v.id, quantity: 1 }]).then(function () {
          $$("[data-p-icon-ok]", list).forEach(function (el) { el.hidden = true; });
          $$("[data-p-icon-add]", list).forEach(function (el) { el.hidden = false; });
          $$("[data-p-label]", list).forEach(function (el) { el.textContent = sec.dataset.labelAdd; });
          $("[data-p-icon-ok]", node).hidden = false; $("[data-p-icon-add]", node).hidden = true;
          label.textContent = sec.dataset.labelAdded;
        }).catch(function () {}).then(function () { btn.disabled = false; });
      });
      list.appendChild(node);
    });
    sec.hidden = false;
  }

  /* ---------- Upsell popup after add to cart: one matched piece at -pct% (code TOR.upsell.code) ---------- */
  function initUpsell() {
    var up = TOR.upsell || {};
    if (!up.on) return;
    var LIMIT = 120000, timer = null;
    // ?wg_test=1 turns the watch gifts on for this cart only (hidden attribute _wg_test), ?wg_test=0 turns them off
    var wgm = /[?&]wg_test=([01])/.exec(location.search);
    if (wgm) {
      Cart.request(TOR.routes.cartUpdate + ".js", { attributes: { _wg_test: wgm[1] === "1" ? "1" : "" } }).then(function () {
        TOR.watchGift = Object.assign({}, TOR.watchGift, { on: wgm[1] === "1" || !!(TOR.watchGift || {}).on && (TOR.watchGift || {}).test !== "1" });
        return Cart.syncDiscount();
      }).catch(function () {}).then(function () {
        location.replace(location.href.replace(/([?&])wg_test=[01]&?/, "$1").replace(/[?&]$/, ""));
      });
    }
    // ?reset_upsell=1 forgets which carts already saw the offer (to preview the popup again)
    if (/[?&]reset_upsell=1/.test(location.search)) {
      try { Object.keys(localStorage).forEach(function (k) { if (k.indexOf("tor:upsell:") === 0) localStorage.removeItem(k); }); } catch (e) {}
    }
    var store = {
      get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    };
    // Picks are ranked once per page (in idle time) and their first images warmed, so the popup opens instantly.
    var MAX = 20, ranked = null, ctx = null;
    function prepare() {
      if (ranked) return ranked;
      var box = $("[data-upsell]"), poolEl = $("[data-bundle-pool]"), jsonEl = $("[data-product-json]");
      if (!box || !poolEl || !jsonEl) return null;
      try {
        ctx = { pool: JSON.parse(poolEl.textContent), product: JSON.parse(jsonEl.textContent), labels: JSON.parse($("[data-upsell-labels]", box).textContent) };
      } catch (err) { return null; }
      ranked = upsellMatch(ctx.pool, ctx.product.handle, ctx.product.title, [ctx.product.handle], 5);
      return ranked;
    }
    var warmed = false;
    function warm() {
      if (warmed || !prepare()) return;
      warmed = true;
      ranked.slice(0, 4).forEach(function (x) { var i = new Image(); i.src = x.p.image; });
    }
    if ($("[data-upsell]")) {
      (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(function () { prepare(); });
      window.addEventListener("load", function () { setTimeout(warm, 2500); });
      ["pointerenter", "touchstart", "focusin"].forEach(function (ev) {
        document.addEventListener(ev, function (e) { if (e.target.closest && e.target.closest("[data-bundle-add], [data-sticky-cta], [data-tier-select]")) warm(); }, { passive: true, capture: true });
      });
    }
    // The popup opens on the click itself, from the cart known before the add plus the pieces being added
    // (no waiting for the network); the real add then runs underneath and only a failure closes it.
    var known = null, shownAt = 0;
    var loadKnown = function () { return fetch(TOR.routes.cart + ".js").then(function (r) { return r.json(); }).then(function (c) { known = c; return c; }).catch(function () {}); };
    if ($("[data-upsell]")) (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(loadKnown);
    function lookup(id) {
      var hit = null;
      [ctx.product].concat(ctx.pool).some(function (p) {
        return p.variants.some(function (v) { if (v.id == id) { hit = { handle: p.handle, price: v.price }; return true; } return false; });
      });
      return hit;
    }
    document.addEventListener("tor:adding", function (ev) {
      if (!known || !prepare()) return;
      var adds = ((ev.detail && ev.detail.items) || []).map(function (it) {
        var h = lookup(it.id);
        return h && { handle: h.handle, price: h.price, original_price: h.price, properties: it.properties || {} };
      });
      if (adds.some(function (x) { return !x; })) return; // unknown piece: wait for the real cart
      var box = $("[data-upsell]");
      open({ token: known.token, attributes: {}, items: (known.items || []).concat(adds) });
      if (box && !box.hidden) shownAt = Date.now();
    });
    document.addEventListener("tor:addfail", function () {
      shownAt = 0;
      var box = $("[data-upsell]");
      if (box && !box.hidden) { box.hidden = true; lockScroll(false, "upsell"); }
    });
    document.addEventListener("tor:added", function (ev) {
      var got = ev.detail && ev.detail.cart;
      if (got) known = got;
      if (shownAt && Date.now() - shownAt < 20000) { // already open from the click
        shownAt = 0;
        var tmp = store.get("tor:upsell:new");
        if (got && got.token && tmp) store.set("tor:upsell:" + got.token, tmp); // a brand-new cart only got its token now
        return;
      }
      if (got) open(got); else loadKnown().then(function (c) { if (c) open(c); });
    });
    function open(c) {
      var box = $("[data-upsell]");
      if (!box || !prepare()) return;
      var product = ctx.product, labels = ctx.labels;
      (function () {
        var items = c.items || [];
        if (items.some(function (it) { return it.properties && it.properties._upsell; })) return; // one per order
        if (offerExpired(c)) return;
        var key = "tor:upsell:" + (c.token || "new");
        // shown again only once the cool-down after the previous offer has passed
        var prev = parseInt(store.get(key) || "0", 10);
        if (prev && Date.now() < prev + (up.cooldownM || 30) * 60000) return;
        var end = Date.now() + LIMIT;
        store.set(key, String(end));
        var inCart = items.map(function (it) { return it.handle; });
        // gift pill: the watch gifts replace the mystery gift when a watch is in the cart
        var gp = $("[data-u-gift]", box), wg = TOR.watchGift || {};
        if (gp) {
          var gt = $("[data-u-gift-text]", gp);
          if (!gp.dataset.mystery) gp.dataset.mystery = gt.textContent;
          var nw = 0;
          items.forEach(function (it) { if (!isGiftLine(it) && isWatchItem(it)) nw += it.quantity || 1; });
          var tier = wg.on ? Math.min(nw, 3) : 0;
          gt.textContent = tier ? gp.dataset.wgTitle + ": " + gp.dataset.wgNames.split("|").slice(0, tier).join(" + ") : gp.dataset.mystery;
          gp.hidden = !tier && !TOR.gift;
        }
        // the code takes pct% off the cheapest piece in the cart: a piece dearer than that saves pct% of the cheapest one
        var cheapest = Math.min.apply(null, items.filter(function (it) { return !isGiftLine(it); }).map(function (it) { return it.original_price || it.price; }).concat([Infinity]));
        var cands = ranked.filter(function (x) { return inCart.indexOf(x.p.handle) < 0; }).slice(0, MAX);
        if (!cands.length) return;
        var list = $("[data-upsell-list]", box), tpl = $("template[data-upsell-item]", box);
        list.innerHTML = "";
        var frag = document.createDocumentFragment();
        cands.forEach(function (x, i) {
          var node = tpl.content.firstElementChild.cloneNode(true);
          $("[data-u-link]", node).href = x.p.url;
          // 240px image (cards are ~200px wide), 480px only on dense screens; the first ones load eagerly
          var img = $("[data-u-img]", node);
          if (i < 4) { img.loading = "eager"; img.fetchPriority = "high"; }
          img.decoding = "async";
          if (x.p.image_l) { img.srcset = x.p.image + " 240w, " + x.p.image_l + " 480w"; img.sizes = "(min-width: 768px) 200px, 46vw"; }
          img.src = x.p.image; img.alt = x.p.alt || x.p.title;
          $("[data-u-title]", node).textContent = x.p.title;
          var off = Math.round(Math.min(x.v.price, cheapest) * up.pct / 100);
          $("[data-u-price]", node).textContent = formatMoney(x.v.price - off);
          $("[data-u-badge]", node).textContent = "−" + Math.round(off * 100 / x.v.price) + "%";
          $("[data-u-compare]", node).textContent = formatMoney(x.v.price);
          var btn = $("[data-u-add]", node);
          btn.addEventListener("click", function () {
            if (Date.now() > end) return expire();
            btn.disabled = true;
            Cart.add([{ id: x.v.id, quantity: 1, properties: { _upsell: "1" } }]).then(function () {
              btn.textContent = labels.added || "";
              setTimeout(close, 450);
            }).catch(function () { btn.disabled = false; });
          });
          frag.appendChild(node);
        });
        list.appendChild(frag);
        list.scrollLeft = 0;
        var clock = $("[data-upsell-timer]", box), bar = $("[data-upsell-bar]", box);
        var tick = function () {
          var left = Math.max(0, end - Date.now());
          var sec = Math.ceil(left / 1000);
          clock.textContent = "0" + Math.floor(sec / 60) + ":" + ("0" + (sec % 60)).slice(-2);
          bar.style.transform = "scaleX(" + (left / LIMIT) + ")";
          if (!left) expire();
        };
        clearInterval(timer);
        timer = setInterval(tick, 250);
        tick();
        box.hidden = false;
        lockScroll(true, "upsell");
      })();
      function expire() {
        clearInterval(timer);
        $$("[data-u-add]", box).forEach(function (b) { b.disabled = true; b.textContent = labels.expired || ""; });
        setTimeout(close, 1200);
      }
      function close() {
        clearInterval(timer);
        if (box.hidden) return;
        box.hidden = true;
        lockScroll(false, "upsell");
      }
      $$("[data-upsell-close]", box).forEach(function (el) { el.onclick = close; });
      document.addEventListener("keydown", function esc(ev) { if (ev.key === "Escape") { close(); document.removeEventListener("keydown", esc); } });
    }
  }

  function initProduct(root) {
    var jsonEl = $("[data-product-json]", root);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var mv = (product.variants || []).filter(function (v) { return v.available; })[0] || (product.variants || [])[0] || {};
    metaTrack("ViewContent", { content_ids: [String(mv.id || product.id)], content_name: product.title, content_type: "product",
      value: (mv.price || product.price || 0) / 100, currency: metaCurrency() });
    var poolEl = $("[data-bundle-pool]", root);
    var pool = [];
    try { pool = poolEl ? JSON.parse(poolEl.textContent) : []; } catch (e) { pool = []; }
    initPairWith(root, product, pool);
    var labels = [];
    try { labels = JSON.parse($("[data-extra-labels]", root).textContent); } catch (e) {}
    var hasChoice = root.dataset.hasChoice === "true";
    var duo = (TOR.bundle && TOR.bundle.duo) || 15, trio = (TOR.bundle && TOR.bundle.trio) || 15;

    var firstAvailable = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var selected = hasChoice ? null : firstAvailable;
    var chosen = selected ? selected.options.slice() : product.options.map(function () { return null; });
    var bundleQty = 2;
    var picks = [null, null];
    var pickVariants = [null, null];

    try {
      var KEY = "tor:recentlyViewed";
      var list = JSON.parse(localStorage.getItem(KEY) || "[]");
      list = [product.handle].concat(list.filter(function (h) { return h !== product.handle; })).slice(0, 12);
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}

    /* Options */
    var optionButtons = $$("[data-option-value]", root);
    function findVariant(opts) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || opts[i] === o; });
      });
    }
    function refreshOptions() {
      optionButtons.forEach(function (btn) {
        var i = parseInt(btn.dataset.optionIndex, 10), val = btn.dataset.optionValue;
        var cands = product.variants.filter(function (v) { return v.options[i] === val; });
        var sold = !cands.some(function (v) { return v.available; });
        btn.disabled = sold;
        btn.setAttribute("aria-pressed", String(chosen[i] === val));
      });
      $$("[data-option-group]", root).forEach(function (g) {
        var i = parseInt(g.dataset.optionGroup, 10);
        var cur = $("[data-option-current]", g);
        if (cur) cur.textContent = chosen[i] || "—";
      });
    }
    optionButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var i = parseInt(btn.dataset.optionIndex, 10), val = btn.dataset.optionValue;
        var next = chosen.slice();
        next[i] = val;
        // fill other options from the best matching variant (available first)
        var exact = findVariant(next.map(function (o, k) { return k === i || chosen[k] != null ? o : null; }));
        var best = exact.filter(function (v) { return v.available; })[0] || exact[0] ||
          product.variants.filter(function (v) { return v.options[i] === val && v.available; })[0] ||
          product.variants.filter(function (v) { return v.options[i] === val; })[0];
        if (best) {
          selected = best;
          chosen = best.options.slice();
          if (window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set("variant", best.id);
            window.history.replaceState({}, "", url.toString());
          }
        }
        refreshOptions();
        refreshPrice();
        refreshBundle();
      });
    });

    function display() { return selected || firstAvailable; }

    function refreshPrice() {
      var v = display();
      var price = v.price, compare = v.compare_at_price || 0;
      var sale = compare > price;
      var set = function (sel, fn) { $$(sel, root).forEach(fn); };
      set("[data-price]", function (el) { el.textContent = formatMoney(price); });
      set("[data-compare]", function (el) { el.textContent = formatMoney(compare); el.hidden = !sale; });
      set("[data-price-label-sale]", function (el) { el.hidden = !sale; });
      set("[data-price-label]", function (el) { el.hidden = sale; });
      set("[data-discount-box]", function (el) { el.hidden = !sale; });
      set("[data-compare-wrap]", function (el) { el.hidden = !sale; });
      if (sale) {
        set("[data-pct]", function (el) { el.textContent = "-" + Math.round((1 - price / compare) * 100) + "%"; });
        set("[data-saving]", function (el) { el.textContent = el.dataset.template.replace("__A__", formatMoney(compare - price)).replace("__P__", Math.round((1 - price / compare) * 100)); });
      }
      set("[data-unit-price]", function (el) { el.textContent = formatMoney(price); });
      set("[data-klarna-title]", function (el) { el.textContent = el.dataset.template.replace("__A__", formatMoney(Math.round(price / 3))); });
    }

    /* Bundle */
    var tiers = $$("[data-tier]", root);
    var tmpl = $("[data-extra-template]", root);
    var extrasBox = document.createElement("div");
    extrasBox.className = "space-y-3";
    var ctaDefaults = $$("[data-cta-label]", root).map(function (el) { return el.innerHTML; });

    var catOf = function (t) {
      t = t.toLowerCase();
      return /watch|orolog|chrono/.test(t) ? "w" : /bracelet|bracciale/.test(t) ? "b" : /necklace|collana|chain|cross|crucifix/.test(t) ? "n" : /sunglass|occhial/.test(t) ? "s" : "o";
    };
    var tone = function (t) {
      var s = t.toLowerCase();
      return /rose ?gold|oro rosa/.test(s) ? "rg" : /silver|argento|steel|acciaio/.test(s) ? "si" : /gold|oro/.test(s) ? "go" : null;
    };
    // Women's pieces, same rule as snippets/vc-match.liquid (isWomensProduct on Lovable); everything else is men's
    var isWomen = function (h) {
      h = " " + h.replace(/^the-/, "").replace(/-\d+$/, "").split("-").join(" ") + " ";
      if (/^ amalfi (black gold|full gold|full gold black|full gold pearl) watch $/.test(h)) return true;
      if (/^ (mirage|riviera|dolcevita|positano) .*watch $/.test(h)) return true;
      if (/^ (cannes|fortuna) .*bracelet $/.test(h)) return true;
      return false;
    };
    var catOfP = function (p) { return catOf(p.title + " " + p.handle); };
    var baseCat = catOf(product.title + " " + product.handle);
    var baseTone = tone(product.title);
    var baseWomen = isWomen(product.handle);
    // complementary category: watch <-> bracelet, necklace <-> sunglasses, pochette -> sunglasses
    var matchCat = { w: "b", b: "w", n: "s", s: "n", o: "s" }[baseCat] || "b";
    var score = function (p) {
      var sc = 0;
      if (isWomen(p.handle) !== baseWomen) sc += 4;
      var c = catOfP(p);
      if (c !== matchCat) sc += c === baseCat ? 3 : 2;
      if (baseTone && tone(p.title) !== baseTone) sc += 1;
      // bracelets: lead with Monaco, Cannes and Riviera, Fortuna last
      if (c === "b") sc += /^the-(monaco|cannes|riviera)-/.test(p.handle) ? -1.5 : /^the-fortuna-/.test(p.handle) ? 0.9 : 0;
      return sc;
    };
    // best matches first: they lead the dropdown and the default pick
    // a little per-product randomness among equally good matches (stable for each product, varies across products)
    var jitter = function (p) {
      var h = 2166136261, k = String(product.id) + ":" + p.handle;
      for (var j = 0; j < k.length; j++) { h ^= k.charCodeAt(j); h = Math.imul(h, 16777619); }
      return ((h >>> 0) % 1000) / 1000 * 0.99;
    };
    pool = pool.map(function (p, i) { return { p: p, s: score(p) + jitter(p), i: i }; })
      .sort(function (x, y) { return x.s - y.s || x.i - y.i; })
      .map(function (x) { return x.p; });
    (function fillDefaults() {
      for (var i = 0; i < 2; i++) {
        var used = picks.filter(Boolean).map(function (p) { return p.handle; });
        picks[i] = pool.filter(function (p) { return used.indexOf(p.handle) < 0; })[0] || null;
      }
    })();

    function pickVariant(i) {
      var p = picks[i];
      if (!p) return null;
      var id = pickVariants[i];
      return p.variants.filter(function (v) { return v.id === id; })[0] ||
        p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    }

    function renderExtras(count) {
      extrasBox.innerHTML = "";
      if (!tmpl || !pool.length) return;
      for (var i = 0; i < count; i++) (function (i) {
        var node = tmpl.content.firstElementChild.cloneNode(true);
        var p = picks[i];
        $("[data-extra-label]", node).textContent = "0" + (i + 2) + " · " + (labels[i] || "");
        $("[data-extra-num]", node).textContent = "#" + (i + 2);
        var taken = picks.filter(function (x, j) { return x && j !== i && j < count; }).map(function (x) { return x.handle; });
        var options = pool.filter(function (x) { return taken.indexOf(x.handle) < 0; });
        var ddBtn = $("[data-extra-dd-btn]", node), ddList = $("[data-extra-dd-list]", node);
        $("[data-extra-dd-text]", node).textContent = p ? (p.title.replace(/^The\s+/i, "")) : "—";
        options.forEach(function (x) {
          var li = document.createElement("li");
          var on = p && x.handle === p.handle;
          li.innerHTML = '<button type="button" role="option" class="w-full flex items-center gap-3 rounded-lg p-1.5 text-left text-[14px] font-medium leading-snug text-[color:var(--color-ink)] hover:bg-[color:var(--color-cream-deep)]' + (on ? ' bg-[color:var(--color-cream-deep)]' : '') + '" aria-selected="' + (on ? "true" : "false") + '"><img alt="" loading="lazy" width="48" height="48" class="h-12 w-12 shrink-0 rounded-md object-cover ring-1 ring-[color:var(--color-gold)]/30"><span class="min-w-0"></span></button>';
          $("img", li).src = x.image;
          $("span", li).textContent = x.title;
          $("button", li).addEventListener("click", function () {
            ddList.hidden = true;
            setPick(x);
          });
          ddList.appendChild(li);
        });
        ddBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          var open = ddList.hidden;
          ddList.hidden = !open;
          ddBtn.setAttribute("aria-expanded", String(open));
          if (open) {
            var cur = $('[aria-selected="true"]', ddList);
            if (cur) ddList.scrollTop = cur.parentNode.offsetTop - 6;
          }
        });
        document.addEventListener("click", function outside(e) {
          if (!document.contains(ddList)) { document.removeEventListener("click", outside); return; }
          if (!ddList.hidden && !e.target.closest("[data-extra-dd]")) { ddList.hidden = true; ddBtn.setAttribute("aria-expanded", "false"); }
        });
        var img = $("[data-extra-img]", node);
        var link = $("[data-extra-link]", node);
        if (p) {
          img.src = p.image; img.alt = p.title;
          link.href = (TOR.routes.root === "/" ? "" : TOR.routes.root) + "/products/" + p.handle;
          $("[data-extra-title]", node).textContent = p.title;
          var pv = pickVariant(i);
          $("[data-extra-price]", node).textContent = pv ? formatMoney(pv.price) : "";
          if (p.variants.length > 1) {
            var wrap = $("[data-extra-variant-wrap]", node);
            var vs = $("[data-extra-variant]", node);
            wrap.hidden = false;
            p.variants.forEach(function (v) {
              var o = document.createElement("option");
              o.value = v.id; o.textContent = v.title; o.disabled = !v.available;
              if (pv && v.id === pv.id) o.selected = true;
              vs.appendChild(o);
            });
            vs.addEventListener("change", function () { pickVariants[i] = parseInt(vs.value, 10); refreshBundle(); });
          }
        } else {
          img.remove();
          $("[data-extra-title]", node).textContent = "—";
        }
        function setPick(np) { picks[i] = np; pickVariants[i] = null; refreshBundle(); }
        var cycle = function (dir) {
          if (!options.length) return;
          var idx = p ? options.map(function (x) { return x.handle; }).indexOf(p.handle) : -1;
          setPick(options[(idx + dir + options.length) % options.length]);
        };
        $("[data-extra-prev]", node).addEventListener("click", function () { cycle(-1); });
        $("[data-extra-next]", node).addEventListener("click", function () { cycle(1); });
        extrasBox.appendChild(node);
      })(i);
    }

    function refreshBundle() {
      var unit = display().price;
      tiers.forEach(function (tier) {
        var qty = parseInt(tier.dataset.tier, 10);
        var disc = qty === 3 ? trio : qty === 2 ? duo : 0;
        var dv = display();
        var sum = unit;
        var compare = Math.max(dv.compare_at_price || 0, unit);
        for (var k = 0; k < qty - 1; k++) {
          var pv = pickVariant(k);
          sum += pv ? pv.price : unit;
          compare += pv ? Math.max(pv.compare_at_price || 0, pv.price) : Math.max(dv.compare_at_price || 0, unit);
        }
        var total = sum - Math.round(sum * disc / 100); // as Shopify: the discount amount is rounded
        var pct = compare > total ? Math.round((1 - total / compare) * 100) : 0;
        var tt = $("[data-tier-total]", tier), tc = $("[data-tier-compare]", tier), tp = $("[data-tier-pct-wrap]", tier);
        if (tt) tt.textContent = formatMoney(total);
        if (tc) { tc.textContent = formatMoney(compare); tc.hidden = pct <= 0; }
        if (tp) { tp.textContent = tp.dataset.template.replace("__A__", formatMoney(compare - total)); tp.hidden = pct <= 0; }
        var active = qty === bundleQty;
        active ? tier.setAttribute("data-open", "") : tier.removeAttribute("data-open");
      });
      var active = tiers.filter(function (t) { return t.hasAttribute("data-open"); })[0];
      var slot = active && $("[data-extras-slot]", active);
      if (slot) { renderExtras(bundleQty - 1); slot.appendChild(extrasBox); }
      // CTA labels
      var needs = hasChoice && !selected;
      var sold = !needs && !(selected || firstAvailable).available;
      var allSold = !product.variants.some(function (v) { return v.available; });
      $$("[data-cta-label]", root).forEach(function (el, i) {
        el.innerHTML = needs && !allSold ? escapeHtml(root.dataset.selectLabel) : (sold || allSold) ? escapeHtml(root.dataset.soldoutLabel) : ctaDefaults[i];
      });
      $$("[data-bundle-add]", root).forEach(function (b) { b.disabled = (sold || allSold); });
      var sticky = $("[data-sticky-label]", root);
      if (sticky) sticky.textContent = needs && !allSold ? root.dataset.selectLabel : (sold || allSold) ? root.dataset.soldoutLabel : root.dataset.mobileLabel;
    }

    tiers.forEach(function (tier) {
      $("[data-tier-select]", tier).addEventListener("click", function () {
        bundleQty = parseInt(tier.dataset.tier, 10);
        refreshBundle();
      });
    });

    $$("[data-bundle-add]", root).forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (hasChoice && !selected) {
          var opts = $("#product-options");
          if (opts) opts.scrollIntoView({ behavior: "smooth", block: "center" });
          var firstGroup = $("[data-option-group]", root);
          if (firstGroup) { firstGroup.classList.add("animate-pulse"); setTimeout(function () { firstGroup.classList.remove("animate-pulse"); }, 1200); }
          return;
        }
        var main = selected || firstAvailable;
        var items = [{ id: main.id, quantity: 1 }];
        for (var k = 0; k < bundleQty - 1; k++) {
          var pv = pickVariant(k);
          if (pv && pv.available) items.push({ id: pv.id, quantity: 1 });
        }
        var all = $$("[data-bundle-add]", root);
        all.forEach(function (b) { b.disabled = true; b.classList.add("opacity-70"); });
        Cart.add(items).catch(function () {}).then(function () {
          all.forEach(function (b) { b.disabled = false; b.classList.remove("opacity-70"); });
        });
      });
    });

    // Sticky CTA: shows once the open tier's add-to-cart button has scrolled above the viewport
    var stickyBar = $("[data-sticky-cta]", root);
    var anchor = $("#bundle-offer-anchor", root);
    if (stickyBar) {
      var onScroll = function () {
        if (!document.contains(stickyBar)) { window.removeEventListener("scroll", onScroll); return; }
        var btn = $("[data-tier][data-open] [data-bundle-add]", root) || anchor;
        var on = btn ? btn.getBoundingClientRect().bottom < 0 : window.scrollY > 400;
        on ? stickyBar.setAttribute("data-on", "") : stickyBar.removeAttribute("data-on");
      };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
      var choose = $("[data-sticky-choose]", stickyBar);
      if (choose && anchor) choose.addEventListener("click", function (e) {
        e.preventDefault();
        // Opens The Duo and scrolls to it, so the second piece can be chosen right away
        var duo = $('[data-tier="2"]', root);
        if (duo && !duo.hasAttribute("data-open")) $("[data-tier-select]", duo).click();
        var target = duo || anchor;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 90, behavior: "smooth" });
      });
    }

    // Gallery dots (mobile)
    var scroller = $("[data-gallery-scroller]", root);
    var gdots = $$("[data-gallery-dot]", root);
    if (scroller && gdots.length) {
      scroller.addEventListener("scroll", function () {
        var step = scroller.scrollWidth / gdots.length;
        var idx = Math.round(scroller.scrollLeft / step);
        gdots.forEach(function (d, i) { i === idx ? d.setAttribute("data-on", "") : d.removeAttribute("data-on"); });
      }, { passive: true });
    }

    refreshOptions();
    refreshPrice();
    refreshBundle();
  }

  function escapeHtml(s) {
    return String(s || "").replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
  }

  /* ---------- Recommendations + recently viewed ---------- */
  function initRecommendations() {
    $$("[data-recommendations]").forEach(function (box) {
      if (box.children.length) return;
      fetch(box.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = $("[data-recommendations]", doc);
        if (fresh && fresh.innerHTML.trim()) { box.innerHTML = fresh.innerHTML; Wardrobe.sync(); }
      }).catch(function () {});
    });
    $$("[data-recent]").forEach(function (box) {
      var row = $("[data-recent-row]", box);
      var list = [];
      try { list = JSON.parse(localStorage.getItem("tor:recentlyViewed") || "[]"); } catch (e) {}
      list = list.filter(function (h) { return h !== box.dataset.exclude; }).slice(0, 8);
      if (!list.length) return;
      var base = TOR.routes.root === "/" ? "" : TOR.routes.root;
      Promise.all(list.map(function (h) {
        return fetch(base + "/products/" + encodeURIComponent(h) + "?view=card").then(function (r) { return r.ok ? r.text() : ""; }).catch(function () { return ""; });
      })).then(function (cards) {
        var html = cards.filter(function (c) { return c && c.indexOf("data-product-card") > -1; }).join("");
        if (!html) return;
        row.innerHTML = html;
        box.hidden = false;
        Wardrobe.sync();
      });
    });
  }

  /* ---------- FAQ page: category chips + search ---------- */
  function initFaqPage() {
    $$("[data-faq-page]").forEach(function (root) {
      var cat = "tutte", q = "";
      var items = $$("[data-faq-item]", root);
      var empty = $("[data-faq-empty]", root);
      var chips = $$("[data-faq-cat]", root);
      var apply = function () {
        var shown = 0;
        items.forEach(function (it) {
          var ok = (cat === "tutte" || it.dataset.cat === cat) && (!q || it.textContent.toLowerCase().indexOf(q) > -1);
          it.hidden = !ok;
          if (ok) shown++;
        });
        if (empty) empty.hidden = shown > 0;
      };
      chips.forEach(function (c) {
        c.addEventListener("click", function () {
          cat = c.dataset.faqCat;
          chips.forEach(function (x) { x.setAttribute("aria-pressed", String(x === c)); });
          apply();
        });
      });
      var input = $("[data-faq-search]", root);
      if (input) input.addEventListener("input", function () { q = input.value.trim().toLowerCase(); apply(); });
    });
  }

  /* ---------- Wardrobe (favourites), saved in this browser ---------- */
  var Wardrobe = {
    key: "tor:wardrobe",
    items: function () {
      try { return JSON.parse(localStorage.getItem(this.key) || "[]"); } catch (e) { return []; }
    },
    save: function (list) {
      try { localStorage.setItem(this.key, JSON.stringify(list)); } catch (e) {}
      this.sync();
    },
    has: function (handle) {
      return this.items().some(function (it) { return it.handle === handle; });
    },
    toggle: function (btn) {
      var d = btn.dataset, list = this.items();
      var saved = list.some(function (it) { return it.handle === d.handle; });
      if (saved) list = list.filter(function (it) { return it.handle !== d.handle; });
      else list.unshift({ handle: d.handle, title: d.title, url: d.url, image: d.image, price: parseInt(d.amount, 10) || 0, variant: parseInt(d.variant, 10) || null });
      this.save(list);
      var w = TOR.wardrobe || {};
      toast(saved ? w.removed : w.added);
    },
    sync: function () {
      var list = this.items();
      var set = {};
      list.forEach(function (it) { set[it.handle] = true; });
      $$("[data-wardrobe-toggle]").forEach(function (b) {
        var on = !!set[b.dataset.handle];
        b.setAttribute("aria-pressed", String(on));
        b.setAttribute("aria-label", on ? b.dataset.labelRemove : b.dataset.labelAdd);
      });
      $$("[data-wardrobe-page]").forEach(function (root) { Wardrobe.renderPage(root, list); });
    },
    renderPage: function (root, list) {
      var empty = $("[data-wardrobe-empty]", root), full = $("[data-wardrobe-full]", root);
      var box = $("[data-wardrobe-list]", root), tpl = $("template[data-wardrobe-item]", root);
      empty.hidden = list.length > 0;
      full.hidden = list.length === 0;
      $("[data-wardrobe-count]", root).textContent = list.length + " " + (list.length === 1 ? root.dataset.labelSingular : root.dataset.labelPlural);
      box.innerHTML = "";
      list.forEach(function (it) {
        var node = tpl.content.firstElementChild.cloneNode(true);
        $$("[data-w-link]", node).forEach(function (a) { a.href = it.url; });
        var img = $("[data-w-image]", node);
        if (it.image) { img.src = it.image; img.alt = it.title; } else img.remove();
        $("[data-w-title]", node).textContent = it.title;
        $("[data-w-price]", node).textContent = it.price ? formatMoney(it.price) : "";
        var add = $("[data-w-add]", node);
        if (!it.variant) add.disabled = true;
        add.addEventListener("click", function () {
          add.disabled = true;
          Cart.add([{ id: it.variant, quantity: 1 }]).catch(function () {}).then(function () { add.disabled = false; });
        });
        $("[data-w-remove]", node).addEventListener("click", function () {
          Wardrobe.save(Wardrobe.items().filter(function (x) { return x.handle !== it.handle; }));
          toast((TOR.wardrobe || {}).removed);
        });
        box.appendChild(node);
      });
    }
  };
  function initWardrobe() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-wardrobe-toggle]");
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        Wardrobe.toggle(btn);
        return;
      }
      var all = e.target.closest && e.target.closest("[data-wardrobe-add-all]");
      if (all) {
        var items = Wardrobe.items().filter(function (it) { return it.variant; }).map(function (it) { return { id: it.variant, quantity: 1 }; });
        if (!items.length) return;
        all.disabled = true;
        Cart.add(items).catch(function () {}).then(function () { all.disabled = false; });
      }
    });
    window.addEventListener("storage", function (e) { if (e.key === Wardrobe.key) Wardrobe.sync(); });
    Wardrobe.sync();
  }
  TOR.Wardrobe = Wardrobe;

  /* ---------- Click-to-play videos and review carousels (ported from the old site) ---------- */
  function initClickVideos(root) {
    $$('button[aria-label="Play"]', root).forEach(function (btn) {
      var box = btn.parentElement;
      var v = box && $("video", box);
      if (!v || btn._tor) return;
      btn._tor = true;
      // Video non ancora scelto in Impostazioni tema > Video del sito: resta la foto, senza tasto play
      if (!(v.getAttribute("src") || "").trim()) { btn.hidden = true; return; }
      var toggle = function (e) {
        if (e) e.stopPropagation();
        if (v.paused) { var p = v.play(); if (p && p.then) p.then(function () { btn.hidden = true; }).catch(function () {}); else btn.hidden = true; }
        else { v.pause(); btn.hidden = false; }
      };
      btn.addEventListener("click", toggle);
      box.addEventListener("click", toggle);
    });
  }

  function initCarousels(root) {
    $$('[aria-roledescription="carousel"]', root).forEach(function (region) {
      if (region._tor) return;
      region._tor = true;
      var track = $('[tabindex="0"]', region);
      var buttons = $$("button", region).filter(function (b) { return !track || !track.contains(b); });
      var counter = $(".tabular-nums", region);
      if (!track || buttons.length < 2) return;
      var total = track.children.length;
      var step = function () { var c = track.firstElementChild; return (c ? c.getBoundingClientRect().width : 300) + 16; };
      var update = function () {
        var idx = Math.min(total, Math.round(track.scrollLeft / step()) + 1);
        if (counter) counter.textContent = String(idx).padStart(2, "0") + " / " + total;
        buttons[0].disabled = track.scrollLeft < 8;
        buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      };
      buttons[0].addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
      buttons[1].addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
      track.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    });
  }

  /* ---------- Product colours: swap to the sibling product in place ---------- */
  function initColorSwap() {
    var busy = false;
    function load(url, push) {
      var main = $("#MainContent");
      if (!main || busy) return;
      busy = true;
      main.style.transition = "opacity .2s";
      main.style.opacity = "0.55";
      fetch(url).then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = $("#MainContent", doc);
        if (!fresh) throw new Error("no main");
        main.innerHTML = fresh.innerHTML;
        document.title = doc.title;
        if (push) history.pushState({ torColor: true }, "", url);
        initReveal(main);
        $$("[data-product]", main).forEach(initProduct);
        initReviews();
        initRecommendations();
        initClickVideos(main);
        initLazyVideos(main);
        initCarousels(main);
        Wardrobe.sync();
      }).catch(function () { window.location.href = url; }).then(function () {
        busy = false;
        main.style.opacity = "";
      });
    }
    document.addEventListener("click", function (e) {
      var a = e.target.closest("[data-color-swatch]");
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      if (a.getAttribute("aria-current") === "true") return;
      load(a.href, true);
    });
    window.addEventListener("popstate", function (e) {
      if (e.state && e.state.torColor) load(location.href, false);
      else if ($("[data-color-swatch]")) window.location.reload();
    });
    if ($("[data-color-swatch]")) history.replaceState({ torColor: true }, "", location.href);
  }

  /* ---------- Boot ---------- */
  // Review cards whose photo/video is not (yet) in Shopify Files hide themselves instead of showing a broken image
  function hideBrokenReviews() {
    var hide = function (el) { var c = el.closest && el.closest(".tor-rev-card"); if (c) c.style.display = "none"; };
    document.addEventListener("error", function (e) { if (e.target && /^(IMG|VIDEO)$/.test(e.target.tagName)) hide(e.target); }, true);
    $$(".tor-rev-card img").forEach(function (img) { if (img.complete && !img.naturalWidth) hide(img); });
    $$(".tor-rev-card video").forEach(function (v) { if (!v.getAttribute("src") && !v.querySelector("source[src]")) hide(v); });
  }

  function boot() {
    hideBrokenReviews();
    initReveal(document);
    initHeader();
    initCart();
    initSheets();
    initAccordions();
    initInfoPages();
    initLiveSearch();
    initWatchClub();
    initKlaviyoForms();
    initKlaviyoOnsite();
    initMetaEvents();
    initAttribution();
    initTabs();
    initHeroVideo();
    initScrollVideo();
    initJewel();
    initManifesto();
    initReviews();
    initFaqPage();
    $$("[data-product]").forEach(initProduct);
    initRecommendations();
    initWardrobe();
    initClickVideos(document);
    initLazyVideos(document);
    initCarousels(document);
    initColorSwap();
    initUpsell();
    renderCartUpsell();
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-more-reviews]");
      if (!btn) return;
      var box = btn.closest("[data-text-reviews]");
      $$("[data-more-item]", box).forEach(function (el) { el.classList.remove("hidden"); });
      btn.parentNode.remove();
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  // Theme editor: re-run section scripts when a section is reloaded
  document.addEventListener("shopify:section:load", function (e) {
    initReveal(e.target);
    $$("[data-product]", e.target).forEach(initProduct);
    initClickVideos(e.target);
    initCarousels(e.target);
    Wardrobe.sync();
  });
})();

/* Tendine lingua/valuta: si chiudono cliccando fuori o con Esc */
document.addEventListener('click', (e) => {
  document.querySelectorAll('details[data-tor-dd][open]').forEach((d) => {
    if (!d.contains(e.target)) d.removeAttribute('open');
  });
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') document.querySelectorAll('details[data-tor-dd][open]').forEach((d) => d.removeAttribute('open'));
});
